import styled from 'styled-components';

const Divider = styled.div`
  border-left: 1px solid #a6a6a6;
  height: 20px;
  margin: 5px 10px;
`;

export default Divider;
